import React from 'react'
import { Link, Navigate } from 'react-router-dom'
import '../misc/avatarDropdown.css'
import { withRouter } from "../withRouter.js";


export default class Name_dropdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isHidden: true,
      avatarUrl: "https://webdev.cse.buffalo.edu/hci/api/uploads/files/ZkhMxfMTnbdJywLC26lZDX5nox35VJatc3rcwIq9nOw.gif",
      logoutComplete: false,
      profileChange: false,
    }
    this.fieldChangeHandler.bind(this)
  }

  fieldChangeHandler(field, e) {
    this.setState({
      [field]: e.target.value
    })
  }

  toggleHidden() {
    this.setState({
      isHidden: !this.state.isHidden
    })
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_API_PATH + "/users/" + sessionStorage.getItem("user"), {
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
    })
      .then(res => res.json())
      .then(
        result => {
          if (result) {
            if (result.attributes) {
              this.setState({
                avatarUrl: result.attributes.pfp || ""
              })
            }
          }
        },
        error => { console.log("error!") }
      )
  }

  // This will log out the user and redirect to the homepage
  logOutFunction() {

    console.log("we are here")

    fetch(process.env.REACT_APP_API_PATH + "/auth/logout", {
      method: "post",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
    })
      .then(
        result => {
          sessionStorage.removeItem("token")
          this.setState({ logoutComplete: true })
          this.props.logout()
        },
        error => { console.log("error!") }
      )

  }

  refreshPage() {
    window.location.reload();
  }

  profileLink = () => {

    window.location.reload();
    console.log("This is at the end blahhh");
  }

  reload() {
    console.log("We are in the relaod")
    window.location.reload();
  }

  render() {
    const linkTarget = {
      pathname: "/user/" + sessionStorage.getItem("user"),
      key: sessionStorage.getItem("user"), // we could use Math.random, but that's not guaranteed unique.
      state: {
        applied: true
      }
    };
    return (
      <div className='dropdown_container'>
        <img className="pfp" src={this.state.avatarUrl} alt="avatar" onClick={this.toggleHidden.bind(this)}></img>

        {!this.state.isHidden &&
          <div className="pfp_dropdown">
            <ul className="pfp_options">

              <Link to="/" style={{ textDecoration: 'none' }}><a className="drop_options"><li className="drop_mobile">Home</li></a></Link>

              <Link to={"/user/" + sessionStorage.getItem("user")} style={{ textDecoration: 'none' }} onClick={linkTarget}><li className="drop_options">Profile</li></Link>

              <li className="drop_mobile">Archived Stories</li>

              <Link to="/leaderboard" style={{ textDecoration: 'none' }}><li className="drop_mobile">Leaderboard</li></Link>

              <Link to="/settings" style={{ textDecoration: 'none' }}><li className="drop_options">Settings</li></Link>

              <Link to="/style-guide" style={{ textDecoration: 'none' }}><li className="drop_options">Style Guide</li></Link>

              <li className="drop_logout" onClick={this.logOutFunction.bind(this)}>
                {this.state.logoutComplete ? <Navigate to="/" /> : ""}
                Log Out
              </li>

            </ul>
          </div>
        }
      </div>
    )
  }

}